import { createAsyncThunk } from '@reduxjs/toolkit'
import { AuthorizationHandler } from '../authorizationHandler'
import { APIError, authenticatedRequest, getExceptionPayload } from '../axiosConfiguration'
import { RegistrationInfo, RegistrationRequest } from '../type/registration'
import * as layoutActions from './layout'

export const submitRegistration = createAsyncThunk<void, RegistrationRequest, { rejectValue: APIError }>(
  'registration/submitRegistration',
  async (payload, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    try {
      const instance = await authenticatedRequest()

      await instance.post(`/user/register`, payload)
      dispatch(layoutActions.endLoading())
    } catch (error) {
      const err = getExceptionPayload(error, 'registration:error.sendRegistration')

      dispatch(layoutActions.endLoading())
      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))
      return rejectWithValue(err)
    }
  },
)

export const getRegistrationInfo = createAsyncThunk<RegistrationInfo, void, { rejectValue: APIError }>(
  'registration/getRegistrationInfo',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const instance = await authenticatedRequest()
      const res = await instance.get<RegistrationInfo>(`/user/whoami`)

      return res.data
    } catch (error) {
      const err = getExceptionPayload(error, 'registration:error.getRegistrationInfo')

      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))
      return rejectWithValue(err)
    }
  },
)

export const submitInviteRegistration = createAsyncThunk<void, RegistrationRequest, { rejectValue: APIError }>(
  'registration/submitInviteRegistration',
  async (payload, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    try {
      const instance = await authenticatedRequest()

      await instance.post(`/user/invite/manage`, {
        user: {
          email: AuthorizationHandler.userEmail,
          partnerId: payload.accessRequest.businessPartner.id,
          ...payload.user,
        },
        userInvitation: {
          notations: payload.accessRequest.notations,
        },
      })
      dispatch(layoutActions.endLoading())
    } catch (error) {
      const err = getExceptionPayload(error, 'registration:error.sendRegistration')

      dispatch(layoutActions.endLoading())
      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))
      return rejectWithValue(err)
    }
  },
)
